<template>
  <v-card
    v-if="active"
    elevation="0"
    outlined
    class="colorDominant colorBreadcrumbs px-0"
    :class="$vuetify.breakpoint.smAndDown ? 'darken-1' : ''"
  >
    <div class="d-flex flex-nowrap transparent px-2 align-center">
      <v-btn fab depressed class="transparent" x-small @click="onBackButton">
        <v-icon size="24">mdi-arrow-left</v-icon>
      </v-btn>
      <v-divider vertical class="my-2 mx-2"></v-divider>
      <!-- <v-app-bar-nav-icon v-on:click="[$router.go(-1)]">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon> -->
      <v-breadcrumbs
        :items="breadcrumbs"
        link
        class="pa-2 d-flex flex-nowrap text-truncate"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item :to="item.href" :disabled="item.disabled">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "breadcrumbs",
  data: () => {
    return {
      active: false,
    };
  },
  mounted() {
    this.active = this.$route.name !== "Sports";
  },
  computed: {
    breadcrumbs: function() {
      const items = [];
      const { params, query } = this.$route;

      if (this.$route.matched[1].path === "/live") {
        const item = {
          text: "Ao vivo",
          disabled: true,
        };
        items.push(item);
      }

      if (this.$route.params.special) {
        const item = {
          text: "Especiais",
          disabled: true,
        };
        items.push(item);
      }

      if (this.$route.params.favorites) {
        const item = {
          text: "Favoritos",
          disabled: true,
        };
        items.push(item);
      }

      if (query.sport || query.live) {
        const item = {
          text: query.sport ? query.sport : query.live,
          disabled: true,
        };
        items.push(item);
      }

      if (query.category) {
        const item = {
          text: query.category ? query.category : params.category,
          // disabled: this.$route.params.special ? true : false,
          disabled: true,
          href: `/category/${params.sport}/${params.category}/?sport=${query.sport}&category=${query.category}`,
        };
        items.push(item);
      }

      if (query.tournament) {
        const item = {
          text: query.tournament ? query.tournament : params.tournament,
          disabled: true,
          href: `/tournament/${params.sport}/${params.category}/${params.tournament}?sport=${query.sport}&category=${query.category}&tournament=${query.tournament}`,
        };
        items.push(item);
      }

      if (query.event) {
        const item = {
          text: query.event ? query.event : params.event,
          disabled: true,
        };
        items.push(item);
      }

      return items;
    },
  },

  methods: {
    onBackButton() {
      if (
        this.$route.name === "BetSuccessCountriesEvent" ||
        this.$route.name === "eventsCountries"
      ) {
        if (this.$store.getters.getCurrentCategory) {
          this.$router.push({
            name: "countries",
            query: {
              sport: this.$route.query.sport,
              category: this.$store.getters.getCurrentCategory,
            },
            params: {
              sport: this.$route.params.sport,
            },
          });
        }
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
